<template>
  <div class="hero purple">
    <div class="width-container svg-container">
      <svg class="logo" ref="animatedLogo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="28 33 367 193">
        <defs>
          <clipPath id="a" transform="translate(8 33.29)">
            <path d="M338.23,125.94h-.14a28.87,28.87,0,0,0-5.62.61c-.43.08-.87.13-1.29.23-.27-.34-.58-.63-.85-1a30.34,30.34,0,0,0-4.17-4.08,29.69,29.69,0,1,0-18.51,53h.14a29.43,29.43,0,0,0,5.75-.62c.39-.08.78-.13,1.17-.22.27.35.59.66.87,1a29.67,29.67,0,1,0,22.65-48.95Zm-.14,50.86A21,21,0,0,1,324,171.31a30.52,30.52,0,0,0,14.64-25.05H319.16a21.3,21.3,0,0,1,8.33-8.93c.58-.34,1.18-.65,1.79-.93a21.16,21.16,0,1,1,8.81,40.4ZM316.6,164.27A21.17,21.17,0,1,1,322,129.42,30.61,30.61,0,0,0,307.46,154h19.45a21.24,21.24,0,0,1-8.52,9.3C317.57,163.8,317.21,164,316.6,164.27Zm10.06-28.77-.11.06.11-.07Zm14.9-2.76Z" style="fill: none"/>
          </clipPath>
          <clipPath id="b" transform="translate(8 33.29)">
            <rect x="91.97" y="67.03" width="54.54" height="13.6" style="fill: none"/>
          </clipPath>
          <clipPath id="c" transform="translate(8 33.29)">
            <rect x="182.24" y="143.44" width="54.54" height="13.6" style="fill: none"/>
          </clipPath>
          <clipPath id="d" transform="translate(8 33.29)">
            <path d="M 363.4 94.93 A 16.29 16.29 0 0 1 357.83 94.09 A 11.45 11.45 0 0 1 353.95 91.79 A 14.75 14.75 0 0 1 351.2 88.52 C 349.2 85.14 349.41 84.06 349.13 80.31 L 349.06 52.26 A 23.85 23.85 0 0 0 347.16 42.81 A 24.83 24.83 0 0 0 341.96 35.05 C 341.53 34.62 341.08 34.23 340.63 33.83 C 340.36 33.6 340.09 33.37 339.81 33.16 S 339.24 32.72 338.95 32.51 S 338.24 32.01 337.88 31.78 S 337.4 31.48 337.15 31.33 C 336.71 31.07 336.27 30.82 335.81 30.58 L 335.34 30.36 C 334.76 30.08 334.17 29.81 333.57 29.57 A 24 24 0 0 0 327 28 H 327 C 326.29 27.93 325.56 27.9 324.84 27.9 S 323.39 27.9 322.67 28 H 322.67 A 24 24 0 0 0 316 29.57 C 315.4 29.81 314.81 30.08 314.23 30.36 L 313.76 30.58 C 313.3 30.82 312.86 31.07 312.42 31.33 C 312.17 31.48 311.93 31.62 311.69 31.78 S 310.97 32.25 310.62 32.51 S 310.04 32.93 309.76 33.16 S 309.21 33.6 308.94 33.83 C 308.49 34.23 308.04 34.62 307.61 35.05 A 24.83 24.83 0 0 0 302.41 42.81 A 23.85 23.85 0 0 0 300.51 52.26 V 125.26 H 267.7 A 19.66 19.66 0 0 0 259.75 126.88 A 21.1 21.1 0 0 0 253.26 131.28 A 20.78 20.78 0 0 0 248.87 137.77 A 19.61 19.61 0 0 0 247.25 145.71 A 19.82 19.82 0 0 0 248.87 153.71 A 20.64 20.64 0 0 0 253.26 160.22 A 20.93 20.93 0 0 0 259.75 164.62 A 19.66 19.66 0 0 0 267.7 166.24 L 299.85 166.32 A 6.71 6.71 0 0 1 302.51 166.84 L 302.51 166.77 A 7.07 7.07 0 0 1 304.65 168.29 A 6.81 6.81 0 0 1 299.82 179.92 H 236.82 V 129.85 A 26.66 26.66 0 0 0 234.68 119.23 A 27.38 27.38 0 0 0 220.15 104.7 A 27.47 27.47 0 0 0 198.89 104.7 A 27.26 27.26 0 0 0 190.24 110.55 A 27.67 27.67 0 0 0 184.41 119.23 A 26.65 26.65 0 0 0 182.28 129.85 V 179.61 H 105.66 L 105.6 80.61 H 105.6 V 67 H 105.6 V 53.39 A 13.23 13.23 0 0 1 106.67 48.08 A 13.57 13.57 0 0 1 113.94 40.81 A 13.69 13.69 0 0 1 124.55 40.81 A 13.57 13.57 0 0 1 131.82 48.08 A 13.23 13.23 0 0 1 132.89 53.39 V 97 H 146.54 V 53.39 A 26.5 26.5 0 0 0 144.4 42.76 A 27.38 27.38 0 0 0 129.87 28.23 A 27.45 27.45 0 0 0 108.62 28.23 A 27.47 27.47 0 0 0 100 34.08 A 27.81 27.81 0 0 0 94.18 42.76 A 26.5 26.5 0 0 0 92 53.39 V 94.28 H 92 V 193.28 L 195.85 193.56 V 157.1 H 195.85 V 143.5 H 195.85 V 129.85 A 13.39 13.39 0 0 1 196.92 124.55 A 13.89 13.89 0 0 1 199.85 120.2 A 13.7 13.7 0 0 1 204.2 117.28 A 13.66 13.66 0 0 1 214.8 117.28 A 13.48 13.48 0 0 1 219.15 120.2 A 13.73 13.73 0 0 1 222.08 124.55 A 13.39 13.39 0 0 1 223.15 129.85 V 140.15 H 223.15 V 161.44 H 223.15 V 193.54 H 299.84 A 20 20 0 0 0 307.84 191.93 A 20.62 20.62 0 0 0 318.71 181 A 20.69 20.69 0 0 0 318.71 165.09 A 20.44 20.44 0 0 0 307.82 154.2 A 20.15 20.15 0 0 0 299.82 152.61 H 299.82 L 267.67 152.53 A 6.72 6.72 0 0 1 262.84 150.53 A 6.7 6.7 0 0 1 261.39 148.34 A 6.93 6.93 0 0 1 260.87 145.65 A 6.71 6.71 0 0 1 261.39 142.99 A 6.74 6.74 0 0 1 265 139.38 A 6.77 6.77 0 0 1 267.67 138.85 H 300.5 V 138.85 H 314.34 V 52.26 A 10 10 0 0 1 315.16 48.26 A 10.46 10.46 0 0 1 320.68 42.71 A 10 10 0 0 1 324.68 41.9 H 324.83 A 10 10 0 0 1 328.83 42.71 A 10.46 10.46 0 0 1 334.35 48.26 A 10 10 0 0 1 335.17 52.26 L 335.35 84.05 A 20.61 20.61 0 0 0 337.49 91.87 A 30.13 30.13 0 0 0 343.49 100.71 A 28.69 28.69 0 0 0 352.38 106.71 A 27.16 27.16 0 0 0 363.24 108.9 L 598.31 109.13 V 95.13 Z" style="fill: none"/>
          </clipPath>
          <clipPath id="e" transform="translate(8 33.29)">
            <path d="M379.16,144.72c-.43-.43-.88-.82-1.33-1.21-.27-.23-.54-.46-.82-.68l-.86-.65c-.35-.25-.71-.5-1.07-.73l-.73-.45c-.44-.26-.89-.51-1.34-.74l-.47-.23c-.58-.28-1.17-.55-1.78-.79a24.21,24.21,0,0,0-6.56-1.54h0c-.72-.07-1.44-.1-2.17-.1s-1.45,0-2.16.1h-.05a24.39,24.39,0,0,0-6.56,1.54h0c-.61.24-1.19.51-1.77.79l-.47.23c-.46.23-.9.48-1.34.74l-.73.45c-.37.23-.72.48-1.07.73s-.59.43-.87.65l-.81.68c-.46.39-.91.78-1.33,1.21a24.78,24.78,0,0,0-5.2,7.76,23.72,23.72,0,0,0-1.9,9.46v31h13.84v-31a10.23,10.23,0,0,1,.81-4,10.43,10.43,0,0,1,5.53-5.55,10,10,0,0,1,4-.81h.15a10,10,0,0,1,4,.81,10.76,10.76,0,0,1,3.29,2.23,10.49,10.49,0,0,1,2.23,3.32,10.23,10.23,0,0,1,.81,4v31h13.84v-31a23.72,23.72,0,0,0-1.9-9.46A24.75,24.75,0,0,0,379.16,144.72Z" style="fill: none"/>
          </clipPath>
          <clipPath id="f" transform="translate(8 33.29)">
            <polygon points="336.96 201.95 336.96 171.79 352.71 158.94 352.74 201.95 336.96 201.95" style="fill: none"/>
          </clipPath>
          <clipPath id="g" transform="translate(8 33.29)">
            <path d="M319.73,178.94a29.68,29.68,0,0,0,48.06-23.31m-8.54,0a21.17,21.17,0,0,1-21.16,21.17,20.68,20.68,0,0,1-6-.89" style="fill: none"/>
          </clipPath>
          <clipPath id="h" transform="translate(8 33.29)">
            <rect x="257" y="124.8" width="43.31" height="15.34" style="fill: none;"></rect>
          </clipPath>
          <clipPath id="i" transform="translate(8 33.29)">
            <path d="M330.33,125.81a30.34,30.34,0,0,0-4.17-4.08A29.67,29.67,0,0,0,278.09,145m8.54,0A21.11,21.11,0,0,1,322,129.42" style="fill: none"/>
          </clipPath>
          <clipPath id="j" transform="translate(8 33.29)">
            <path d="M165.7,148.6a21.68,21.68,0,0,1-3,4.09,20.62,20.62,0,0,1-6.55,4.56,19.45,19.45,0,0,1-8,1.68,11,11,0,0,1-5-1.24l22.06-27.9h0l10.25-11.9a34.31,34.31,0,0,0-3.63-4.53A33.68,33.68,0,0,0,165,108a33.07,33.07,0,0,0-8-3.47,32.71,32.71,0,0,0-17.77,0,33.32,33.32,0,0,0-14.8,8.87,35.4,35.4,0,0,0-5.26,7,35.11,35.11,0,0,0,5.26,41.81,34,34,0,0,0,6.8,5.42,33.27,33.27,0,0,0,8,3.5,32.71,32.71,0,0,0,17.77,0,32.76,32.76,0,0,0,8-3.5,34.14,34.14,0,0,0,6.78-5.42,35.46,35.46,0,0,0,3.3-4Zm-35.37-.41a8.1,8.1,0,0,1-1.22-2.23,21.3,21.3,0,0,1,11-27.77,19.44,19.44,0,0,1,8-1.68,19.66,19.66,0,0,1,7.06,1.31Z" style="fill: none"/>
          </clipPath>
          <clipPath id="k" transform="translate(8 33.29)">
            <rect x="184.3" y="55.75" width="38.34" height="14.15" style="fill: none"/>
          </clipPath>
          <clipPath id="l" transform="translate(8 33.29)">
            <path d="M 84 93.92 A 38.76 38.76 0 0 1 48.49 101.86 A 39 39 0 0 1 31.33 91.86 A 39.22 39.22 0 0 1 21.33 74.7 A 39.2 39.2 0 0 1 21.33 54.08 A 39 39 0 0 1 31.33 36.89 A 39 39 0 0 1 48.49 26.89 A 37.88 37.88 0 0 1 58.79 25.5 A 38.78 38.78 0 0 1 72.26 27.89 A 37.31 37.31 0 0 1 84 34.75 L 76 47.85 A 22.61 22.61 0 0 0 68.19 42.37 A 23.94 23.94 0 0 0 58.76 40.46 A 23.16 23.16 0 0 0 49.43 42.35 A 24.61 24.61 0 0 0 41.83 47.46 A 24 24 0 0 0 36.7 55.06 A 23.19 23.19 0 0 0 34.81 64.36 A 22.85 22.85 0 0 0 36.7 73.61 A 24.22 24.22 0 0 0 49.45 86.32 A 23.15 23.15 0 0 0 58.78 88.2 A 23.76 23.76 0 0 0 68.21 86.29 A 22.45 22.45 0 0 0 76 80.82 Z M 81.33 156.92 C 81.33 160.77 81.33 171.59 79.14 176.35 A 30 30 0 0 1 73.14 185.19 A 28.69 28.69 0 0 1 64.25 191.19 A 27.17 27.17 0 0 1 53.39 193.39 L -200 193.63 V 181 L 53.27 180.77 A 16.33 16.33 0 0 0 58.84 179.93 A 11.45 11.45 0 0 0 62.72 177.63 A 14.2 14.2 0 0 0 65.25 173 C 67.25 169.62 67.25 163.28 66.76 160.42 A 6.28 6.28 0 0 1 64.41 162.6 A 16.78 16.78 0 0 1 61.01 163.98 A 23.15 23.15 0 0 1 57.13 164.72 C 55.78 164.85 54.53 164.92 53.37 164.92 A 29.46 29.46 0 0 1 42.51 162.92 A 26 26 0 0 1 27.61 148.15 A 31.83 31.83 0 0 1 25.42 136 A 29.85 29.85 0 0 1 27.61 124.5 A 28.7 28.7 0 0 1 33.61 115.3 A 27.64 27.64 0 0 1 42.5 109.22 A 27 27 0 0 1 53.37 107 A 20.84 20.84 0 0 1 58.63 107.67 A 26.43 26.43 0 0 1 63.69 109.51 A 30.58 30.58 0 0 1 68.37 112.27 A 37.27 37.27 0 0 1 72.53 115.69 L 81.32 109.2 Z M 66.18 130.42 A 15.87 15.87 0 0 0 63.18 125.67 A 14.72 14.72 0 0 0 58.76 122.35 A 11.92 11.92 0 0 0 53.37 121.1 A 14.82 14.82 0 0 0 47.98 122.1 A 12.23 12.23 0 0 0 43.58 124.96 A 13.59 13.59 0 0 0 40.64 129.63 A 17.76 17.76 0 0 0 39.57 136 A 16.9 16.9 0 0 0 40.64 142.16 A 14.18 14.18 0 0 0 43.58 146.83 A 12.83 12.83 0 0 0 47.98 149.83 A 13.88 13.88 0 0 0 53.37 150.83 A 12.05 12.05 0 0 0 58.76 149.58 A 14.92 14.92 0 0 0 63.18 146.25 A 15.87 15.87 0 0 0 66.18 141.5 C 66.9 139.76 66.9 132.25 66.17 130.46 Z M 173.1 39.08 A 8.64 8.64 0 0 0 172.33 38.15 A 9.07 9.07 0 0 0 169.5 36.08 A 8.18 8.18 0 0 0 162.57 36.08 A 8.88 8.88 0 0 0 159.76 38.15 A 10.43 10.43 0 0 0 158.99 39.15 H 158.99 V 97.27 H 173.07 V 39.12 L 173.02 39.12 Z M 234.34 16.21 V 113.63 H 234.34 A 10.71 10.71 0 0 1 233.51 117.83 A 10.79 10.79 0 0 1 227.78 123.55 A 10.5 10.5 0 0 1 223.57 124.41 H 219.63 A 10.11 10.11 0 0 1 217.35 123.74 A 10.67 10.67 0 0 1 210.79 113.82 H 210.71 A 0.66 0.66 0 0 0 210.8 113.63 V 16.79 H 196.63 V 113.63 A 1.06 1.06 0 0 0 196.63 113.82 H 196.63 A 24.24 24.24 0 0 0 198.58 123.51 C 198.71 123.82 198.87 124.11 199.02 124.41 A 25 25 0 0 0 211.87 136.8 A 23.54 23.54 0 0 0 218.55 138.56 H 223.55 A 24.15 24.15 0 0 0 233.22 136.61 A 24.94 24.94 0 0 0 245.9 124.61 C 246.11 124.18 246.33 123.77 246.52 123.33 C 247.82 120.33 248.41 113.64 248.41 113.64 V 16.21 Z M 282.34 39.08 A 8.64 8.64 0 0 0 281.57 38.15 A 9.07 9.07 0 0 0 278.74 36.08 A 8.18 8.18 0 0 0 271.81 36.08 A 8.88 8.88 0 0 0 269 38.15 A 10.43 10.43 0 0 0 268.23 39.15 H 268.23 V 97.27 H 282.31 V 39.12 L 282.26 39.12 Z" style="fill: none"/>
          </clipPath>
          <clipPath id="m" transform="translate(8 33.29)">
            <polygon points="240.79 140.15 217.54 141.75 214.07 109.82 233.37 108.02 240.79 140.15" style="fill: none"/>
          </clipPath>
          <mask id="n">
            <rect x="200" y="500" width="100%" height="100%" fill="white" />
            <circle cx="282.5" cy="588" r="5" fill="black"/>
            <circle cx="420.5" cy="588" r="5" fill="black"/>
            <circle cx="457" cy="588" r="5" fill="black"/>
          </mask>
        </defs>
          <body-line :convertedWindowSize="convertedWindowSize" :windowWidth="windowWidth" :windowHeight="windowHeight"/>
          <g class="margins">
            <path id="margin-bottom" :d="`M387.35,226 C387.35,279.40931 387.35,332.81862 387.35,${margins.bottom}`" style="stroke-width: 14px;"></path>
            <path id="margin-right" :d="`M394.5,135.25 C470.00316,135.25 545.50633,135.25 ${margins.right},135.25 `" style="stroke-width: 14px"></path>
            <path id="margin-left" :d="`M31,220.4 C-48.08218,220.4 -127.16435,220.4 ${margins.left},220.4 `" style="stroke-width: 12.75px"></path>
          </g>
          <g class="logo-container">
            <logo id="logo" />
            <g class="long-path persist-dot">
              <g style="clip-path: url(#d)">
                <path class="path" d="M 139.73 96.22 V 50.9 C 139.73 44.62 132.25 33.21 119.25 33.21 C 105.69 33.21 98.8 44 98.8 50 V 181.92 A 5.1 5.1 0 0 0 103.89 186.79 L 184.47 187.13 A 4.8 4.8 0 0 0 189.33 182.33 V 127.52 C 189.33 120.28 197.44 108.9 209.51 108.9 S 230.06 121.13 230.06 127.51 V 182.21 A 5.35 5.35 0 0 0 235.37 187.21 C 250.6 187.21 296.82 187.04 300.79 187.04 A 13.55 13.55 0 0 0 313.79 173.21 C 313.79 163.42 306.27 159.51 301.03 159.51 H 265.49 C 259.49 159.51 253.78 152.59 253.78 146.09 S 258.08 132.47 264.44 132.47 H 302.73 C 305.39 132.47 307.45 129.94 307.46 127.28 C 307.54 110.64 307.75 55.72 307.75 51.21 C 307.75 45.88 311.43 34.83 324.75 34.83 S 342.4 45.08 342.4 49.27 S 342.4 81.01 342.4 85.58 C 342.4 94.34 352.75 101.86 360.67 101.86 C 364.61 101.86 387 101.99 387 101.99" transform="translate(8 33.29)" style="stroke-width: 24px"/>
              </g>
              <circle class="target salmon" cx="147.73" cy="130.56" r="7" />
              <circle class="target pink" cx="147.73" cy="130.56" r="7" />
            </g>
            <g class="a1">
              <g style="clip-path: url(#b)">
                <path class="path" d="M146.52,73.91H92" transform="translate(8 33.29)" style="stroke-width: 14.88px"/>
              </g>
              <path class="a1-arch stroke-salmon" d="M136.59,70.73V53.39a16.84,16.84,0,0,0-1.36-6.74A17.2,17.2,0,0,0,126,37.4a17.38,17.38,0,0,0-13.48,0,17.26,17.26,0,0,0-9.25,9.25,16.84,16.84,0,0,0-1.36,6.74V70.73Z" />
              <path class="a1-arch stroke-pink" d="M131.1,65.24V53.39a11.54,11.54,0,0,0-.93-4.61,11.83,11.83,0,0,0-6.32-6.32,11.87,11.87,0,0,0-9.21,0,11.83,11.83,0,0,0-6.32,6.32,11.54,11.54,0,0,0-.93,4.61V65.24Z" />
              <circle class="target salmon" cx="154.52" cy="107.13" r="6.93" />
              <circle class="target pink" cx="154.52" cy="107.13" r="6.93" />
            </g>
            <g class="a2">
              <g style="clip-path: url(#c)">
                <path class="path" d="M182.27,150.49h54.54" transform="translate(8 33.29)" style="stroke-width: 24.35px"/>
              </g>
              <path id="a2-arch-1" class="a2-arch stroke-salmon" d="M192.5,147.24V129.9a16.84,16.84,0,0,1,1.36-6.74,17.35,17.35,0,0,1,9.25-9.25,17.38,17.38,0,0,1,13.48,0,17.54,17.54,0,0,1,5.53,3.72,17.29,17.29,0,0,1,3.71,5.53,16.84,16.84,0,0,1,1.36,6.74v17.34Z" />
              <path id="a2-arch-2" class="a2-arch stroke-pink" d="M198,141.75V129.9a11.58,11.58,0,0,1,.93-4.61,11.75,11.75,0,0,1,2.54-3.78,11.92,11.92,0,0,1,3.78-2.54,11.87,11.87,0,0,1,9.21,0,11.92,11.92,0,0,1,3.78,2.54,11.75,11.75,0,0,1,2.54,3.78,11.58,11.58,0,0,1,.93,4.61v11.85Z" />
              <circle class="target salmon" cx="190.36" cy="183.54" r="6.93" />
              <circle class="target pink" cx="190.36" cy="183.54" r="6.93" />
            </g>
            <g class="jump-paths">
              <g class="i1" transform="translate(8 33.29)">
                <path class="i1-path stroke-pink" d="M166,40.79a18.65,18.65,0,1,1,18.65-18.65A18.65,18.65,0,0,1,166,40.79Z" style="stroke-width: 7px;"/>
                <path class="i1-path stroke-salmon" d="M157.25,30.92a12.42,12.42,0,1,0,0-17.56A12.42,12.42,0,0,0,157.25,30.92Z" /> 
                <path class="i1-dot" d="M175.8,22.14A9.34,9.34,0,0,1,175,26,9.79,9.79,0,0,1,172.9,29a10.17,10.17,0,0,1-3.14,2.1,9.94,9.94,0,0,1-7.67,0,9.88,9.88,0,0,1-5.2-5.18,9.74,9.74,0,0,1,0-7.59A10.07,10.07,0,0,1,159,15.25a10.18,10.18,0,0,1,3.11-2.09,9.82,9.82,0,0,1,7.67,0,10.33,10.33,0,0,1,3.14,2.09A9.81,9.81,0,0,1,175,18.36,9.41,9.41,0,0,1,175.8,22.14Z" style="fill: #8447ff"/>
              </g>
              <g class="i2" transform="translate(8 33.29)">
                <path class="i2-path stroke-pink" d="M288.5,35.33a18.65,18.65,0,1,0-26.37,0A18.65,18.65,0,0,0,288.5,35.33Z" style="stroke-width: 7px"/>
                <path class="i2-path stroke-salmon" d="M275.31,34.56a12.42,12.42,0,1,1,12.42-12.42A12.42,12.42,0,0,1,275.31,34.56Z" />
                <path class="i2-dot" d="M285.15,22.14a9.5,9.5,0,0,1-.77,3.81A9.79,9.79,0,0,1,282.26,29a10.29,10.29,0,0,1-3.14,2.1,9.94,9.94,0,0,1-7.67,0,9.92,9.92,0,0,1-3.11-2.1A10,10,0,0,1,266.25,26a9.62,9.62,0,0,1,0-7.59,9.73,9.73,0,0,1,5.2-5.2,9.82,9.82,0,0,1,7.67,0,10.45,10.45,0,0,1,3.14,2.09,9.81,9.81,0,0,1,2.12,3.11A9.57,9.57,0,0,1,285.15,22.14Z" style="fill: #8447ff"/>  
              </g>
              <g style="clip-path: url(#l)">
                <g class="jump-path1">
                  <path class="path" data-dot-width="7.7" d="M82.37,43c-13-16.94-54.89-13.33-54.89,21.3,0,31.4,38.7,42.31,55.37,19.9A667.45,667.45,0,0,0,120.77,27C135.26,2.64,141.33-16.33,166-16.33" transform="translate(8 33.29)" style="stroke-width: 19px"/>
                  <path class="path" data-dot-width="7.08" d="M166-16.33c25.41,0,37.5,18,37.87,33.12,0,0,.38,92.8.38,98.89,0,8,8.74,15.91,17.75,15.91s19.78-5.81,19.78-15.7V-9.48c0-9.89,9.67-15.7,17.77-15.7" transform="translate(8 33.29)" style="stroke-width: 16px"/>
                  <path class="path" data-dot-width="7.04" d="M259.51-25.18c8.09,0,15.94,7.91,15.94,15.91,0,1.58.21,57.76.39,105.51" transform="translate(8 33.29)" style="stroke-width: 15px;"/>
                </g>
                <g class="jump-path2">
                  <path class="path" data-dot-width="7.18" d="M 166.65 97.27 c -0.35 -32.69 -0.72 -65.37 -0.72 -65.37 C 165.93 -0.09 143 -17 123.12 -17 S 83 4.73 83 31.73 c 0 6.14 -0.55 60.33 -0.67 73.31 s -8.31 29.18 -8.31 29.18 S 66.57 114 53.35 114 S 33 123.41 33 136 s 10.19 22.74 21.59 22.74 c 9.45 0 19.94 -28.6 18.6 -30.71 c -0.1 2.07 0.91 33.93 0.91 40.33 c 0 8.95 -10.77 18.44 -19.56 18.44 H 19.5" transform="translate(8 33.29)" style="stroke-linejoin: round;stroke-width: 16px;"/>
                </g>
              </g>
              <circle class="jp1-target target salmon" cx="90.28" cy="76.31" r="7.7" />
              <circle class="jp1-target target pink" cx="90.28" cy="76.31" r="7.7" />
              <circle class="jp2-target target persist-dot salmon" cx="174.03" cy="130.56" r="7.18" />
              <circle class="jp2-target target persist-dot pink" cx="174.03" cy="130.56" r="7.18" />
              <g class="t">
                <g style="clip-path: url(#k)">
                  <path class="path" d="M184.3,62.83h38.33" transform="translate(8 33.29)" style="stroke-width: 14.88px"/>
                </g>
                <circle class="target salmon" cx="192.3" cy="96.12" r="7.08" />
                <circle class="target pink" cx="192.3" cy="96.12" r="7.08" />
              </g>
              <g class="g">
                <path class="g-arch stroke-salmon" d="M70.61,136a17.4,17.4,0,0,0-1.36-6.76,19.44,19.44,0,0,0-3.71-5.79,18.63,18.63,0,0,0-5.49-4,15,15,0,0,0-6.69-1.52,18.26,18.26,0,0,0-6.59,1.25,15.28,15.28,0,0,0-5.46,3.48,16.48,16.48,0,0,0-3.65,5.7A20.7,20.7,0,0,0,36.23,136a20.06,20.06,0,0,0,1.33,7.51,17.11,17.11,0,0,0,3.65,5.7,16,16,0,0,0,5.45,3.64,17.68,17.68,0,0,0,6.7,1.28,15.22,15.22,0,0,0,6.69-1.53C69.11,148.22,70.61,141.26,70.61,136Z" transform="translate(8 33.29)" />
                <path class="g-arch stroke-pink" d="M65.42,136a12.65,12.65,0,0,0-1-4.81,13.84,13.84,0,0,0-2.59-4.11,12.87,12.87,0,0,0-3.83-2.88,10.31,10.31,0,0,0-4.67-1.09,12.9,12.9,0,0,0-4.67.84,10.74,10.74,0,0,0-3.81,2.48,11.76,11.76,0,0,0-2.55,4.05,15.28,15.28,0,0,0-.93,5.52,14.5,14.5,0,0,0,.93,5.33,12.15,12.15,0,0,0,2.55,4A11,11,0,0,0,48.71,148a12,12,0,0,0,4.67.91,10.43,10.43,0,0,0,4.67-1.08,13.22,13.22,0,0,0,3.83-2.88,14,14,0,0,0,2.59-4.12A12.64,12.64,0,0,0,65.42,136Z" transform="translate(8 33.29)" />
              </g>
            </g>
            <g class="e">
              <g style="clip-path: url(#j)">
                <path class="path" d="M137.78,151.61l28.31-35c-8.91-9.51-28.81-9-38,2-12.13,14.51-8.53,33.14,3.88,42.23,13.23,9.7,31.65,4.95,38.53-7.33" transform="translate(8 33.29)" style="stroke-linecap: round;stroke-width: 16.23px"/>
              </g>
              <circle class="target salmon" cx="144.44" cy="186.71" r="7.78" />
              <circle class="target pink" cx="144.44" cy="186.71" r="7.78" />
            </g>
            <g class="n persist-dot">
              <g style="clip-path: url(#e)">
                <path class="path" d="M344.84,193V159c0-5.33,6.25-14.21,17.15-14.21S379.5,152.47,379.5,159s.14,34,.14,34" transform="translate(8 33.29)" style="stroke-width: 14.88px"/>
              </g>
              <circle class="target body-target salmon" cx="352.61" cy="225.65" r="7.02" />
              <circle class="target body-target pink pink-target" cx="352.61" cy="225.64" r="7.02" />
            </g>
            <!-- <use xlink:href="#logo" href="#logo" style="clip-path: url(#f)" />
            <use xlink:href="#logo" href="#logo" style="clip-path: url(#h)" /> -->
            <!-- had to break out into component becuase use didn't work on safari/firefox -->
            <logo id="logo" style="clip-path: url(#f)"/>
            <logo id="logo" style="clip-path: url(#h)"/>
            <g class="a-mask" style="clip-path: url(#m)">
              <!-- <use xlink:href="#a2-arch-1" href="#a2-arch-1"/>
              <use xlink:href="#a2-arch-2" href="#a2-arch-2"/> -->
              <path class="a2-arch stroke-salmon" d="M192.5,147.24V129.9a16.84,16.84,0,0,1,1.36-6.74,17.35,17.35,0,0,1,9.25-9.25,17.38,17.38,0,0,1,13.48,0,17.54,17.54,0,0,1,5.53,3.72,17.29,17.29,0,0,1,3.71,5.53,16.84,16.84,0,0,1,1.36,6.74v17.34Z" />
              <path class="a2-arch stroke-pink" d="M198,141.75V129.9a11.58,11.58,0,0,1,.93-4.61,11.75,11.75,0,0,1,2.54-3.78,11.92,11.92,0,0,1,3.78-2.54,11.87,11.87,0,0,1,9.21,0,11.92,11.92,0,0,1,3.78,2.54,11.75,11.75,0,0,1,2.54,3.78,11.58,11.58,0,0,1,.93,4.61v11.85Z" />
            </g>
          </g>
          <g class="intro" id="intro-text-container" :transform="introTextContainer">
            <circle class="intro-dot-1 teal" cx="282" cy="588" r="0" />
            <circle class="intro-dot-2 teal" cx="420.5" cy="588" r="0" />
            <circle class="intro-dot-3 teal" cx="457" cy="588" r="0" />
            <text id="intro-text" x="250" y="615" style="mask: url(#n); font-family: Righteous; font-size: 40px; fill: #a5a5ff;">Hi, I'm <tspan style="fill: #FF779B">caitlin</tspan></text>
            <path class="intro-period-path" style="stroke: none; fill: none;" transform="translate(-149 58) scale(.575)" d="M463,826.9c77.5-264.5,251-14,285.5,99.5,99-218,242-19,242,0,5-69,65-52,63-1,16-45,57.5-26,57.5,35.5"/>
            <circle class="intro-period teal" cx="0" cy="0" r="0"/>
          </g>
      </svg>
    </div> 
    <div class="scroll-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85 85">
        <circle cx="42.5" cy="42.5" r="40" style="fill: none; stroke: #ff779c; stroke-width: 5px;"/>
        <polyline class="scroll-arrow" points="21.98 44.4 42.5 62.92 63.02 44.4" style="stroke-linecap: round; stroke-linejoin: round; fill: none; stroke: #ffb0f4; stroke-width: 5px;"/>
        <polyline class="scroll-arrow" points="21.98 29.12 42.5 47.64 63.02 29.12" style="stroke-linecap: round; stroke-linejoin: round; fill: none; stroke: #ffb0f4; stroke-width: 5px;"/>
      </svg>
    </div>
  </div>
</template>

<script>

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

import BodyLine from './BodyLine.vue'
import Logo from './Logo.vue'

gsap.registerEffect({
  name: "drawLine",
  effect: (paths, config) => {
    let tl = gsap.timeline({});

    //fade in dot
    tl.to(config.dot, {duration: .25, opacity: 1, ease: "none"});
    
    //creat set of tweens for each path
    paths.forEach(function(path, i){
      //set relative ratio based on length of line
      let $duration = config.duration == "ratio" ? path.getTotalLength()/250 : config.duration;
      let dotDuration = config.end ? $duration*config.end : $duration;
      
      //set dot width to width of line when switching between segments
      let dotWidth = path.getAttribute("data-dot-width");
      //label tween
      let label = "path" + i + "-=.12";

      let $ease = config.ease ?? "sine.inOut";

      //animate line drawing
      tl.fromTo(path, {drawSVG: "0%"}, {duration: $duration, drawSVG: "100%", ease: $ease, onComplete: ()=> {config.onComplete ? config.onComplete() : null }}, label);

      if (dotWidth !== null) {
        tl.to(config.dot, {duration: .1, attr: {r: dotWidth}, ease: $ease}, label);
      }

      //animate dot along path
      tl.to(config.dot, {
        motionPath: {
          path: path,
          align: paths.length > 1 ? null : path,
          alignOrigin: [0.5, 0.5],
          offsetX: config.offsetX ?? 0,
          offsetY: config.offsetY ?? 0,
          immediateRender: true,
          start: ()=> config.start ?? 0,
          end: ()=> config.end ?? 1
        },
        duration: dotDuration - .05,
        ease: $ease,
        stagger: -.04
      },label);

      //if last path animate out dot
      let dotEl = document.querySelector(config.dot)
      let exclude = (elem)=> {
        if (elem.classList.contains("persist-dot")) return false
        if (elem.parentNode.classList.contains("persist-dot")) return false
        return true
      }
      if (i == (paths.length-1) && exclude(dotEl)){
        tl.to(config.dot, {duration: .5, scale: 0, transformOrigin: "center center", ease: "back.in(2.5)"}, ">-.35");
      }
    });
    return tl
  },
  extendTimeline: true,
});

export default {
  name: "MainSvg",
  components: {
    BodyLine, 
    Logo
  },
  props: ["convertedWindowSize"],
  data() {
    return {
      introTl: null
    }
  },
  computed: {
    windowWidth(){
      if (!this.convertedWindowSize) return {}
      return this.convertedWindowSize.left + this.convertedWindowSize.width;
    },
    windowHeight(){
      if (!this.convertedWindowSize) return {}
      return this.convertedWindowSize.top + this.convertedWindowSize.height;
    },
    margins() {
      if (!this.convertedWindowSize) return {bottom: 397.41, left: -255.82, right: 670.23};
      return {
        bottom: (this.windowHeight).toFixed(2),
        right: (this.convertedWindowSize.right + 15).toFixed(2), 
        left: (this.convertedWindowSize.left - 15).toFixed(2)
      }
    },
    introTextContainer() {
      if (!this.convertedWindowSize) return "translate(0 0)";
      let section1 = this.SVGBoundingClientRect(document.querySelector(".section-1"));
      let intro = this.SVGBoundingClientRect(document.querySelector("#intro-text"));
      let introMarginTop = (section1.height - intro.height)/2;
      let y = (section1.y + introMarginTop) - (615 - intro.height*.75)
      if (this.isMobile() ) return `translate(-150 ${y})`
      else return `translate(-75 ${y})`;
    },
  },
  methods: {
    setupIntroTimeline() {
      let bounce = gsap.timeline({paused: true, id: "bounce"});
      bounce.fromTo(".svg-container #margin-bottom", {drawSVG: ()=>"0%"}, {drawSVG: ()=>"35%", repeat: -1, yoyo: true, duration: .5, ease: "circ.out"});
      bounce.to(".svg-container .body-target", {duration: .5, ease: "circ.out", immediateRender: false, yoyo: true, repeat: -1,
      motionPath: {
                  path: ".svg-container #margin-bottom",
                  end: .35,
                  align: ".svg-container #margin-bottom", 
                  alignOrigin: [0.5, 0.5]
                }}, "<");

      let scrollIcon = gsap.timeline({paused: true, id: "scrollIcon", repeat: -1, delay: .5, repeatDelay: .2});
      scrollIcon.to(".scroll-arrow", {y: "+=8", duration: .3, ease: "circ.Out", stagger: {each: .2}})
      scrollIcon.to(".scroll-arrow", {y: "-=8", duration: .3, ease: "circ.Out"})

      let tl1 = gsap.timeline({});
      tl1.drawLine(".svg-container .long-path .path", {dot: ".svg-container .long-path .target", duration: 4.75, ease: "sine.in"}, "start")
      tl1.drawLine("#margin-right", {dot: ".svg-container .long-path .target", duration: "ratio", ease: "sine.out"}, ">-.15")
      tl1.drawLine(".svg-container .n .path", {dot: ".svg-container .n .target", duration: 1, ease: "circ.in", onComplete: ()=> { 
        bounce.play() 
      }}, ">-=2")
      tl1.drawLine(".svg-container .a1 .path", {dot: ".svg-container .a1 .target", duration: .5}, "start+=1.5")
      tl1.from(".svg-container .a1-arch", {duration: .8, drawSVG: 0, ease: "sine.inOut", stagger: .1}, "<+.5");
      tl1.drawLine(".svg-container .e .path", {dot: ".svg-container .e .target", duration: 1.5}, "start+=2.5")
      tl1.drawLine(".svg-container .a2 .path", {dot: ".svg-container .a2 .target", duration: .5}, "start+=3.25")
      tl1.from(".svg-container .a2-arch", {duration: .8, drawSVG: 0, ease: "sine.inOut", stagger: .1}, "<+.5");
      

      let tl2 = gsap.timeline({paused: true});
      tl2.from(".svg-container .logo .path-1", {duration: 2, drawSVG: 0, ease: "sine.inOut"},"start");
      tl2.from(".svg-container .logo .path-2", {duration: 2, drawSVG: 0, ease: "sine.inOut"}, "<.15");
      tl2.from(".svg-container .logo .path-3", {duration: 2, drawSVG: 0, ease: "sine.inOut"},"start");
      tl2.from(".svg-container .logo .path-4", {duration: 2, drawSVG: 0, ease: "sine.inOut"}, "<.15");
      tl2.from(".svg-container .logo .path-5", {duration: 2.25, drawSVG: 0, ease: "sine.inOut"},"start");

      let tl3 = gsap.timeline({paused: true});
      tl3.drawLine(".svg-container .jump-path1 .path", {dot: ".svg-container .jp1-target", duration: "ratio", offsetX: -82.75, offsetY: -43}, "start");
      tl3.drawLine(".svg-container .t .path", {dot: ".svg-container .t .target", duration: .5, offsetX: 0, offsetY: 0}, "start+=2");
      tl3.from(".svg-container .i2-dot", {duration: .75, opacity: 0, y: 70, scale: .8, transformOrigin: "center center", ease: "back.out"}, "start+=2.90");
      tl3.from(".svg-container .i2-path", {duration: 1, drawSVG: 0, ease: "sine.inOut", stagger: .1}, "start+=3");

      let tl4 = gsap.timeline({paused: true});
      tl4.addLabel("start", 0);
      tl4.drawLine(".svg-container .jump-path2 .path", {dot: ".svg-container .jp2-target", duration: "ratio", ease: "sine.in"}, "start");
      tl4.drawLine("#margin-left", {dot: ".svg-container .jp2-target", duration: "ratio", ease: "sine.out"}, ">-.2")
      tl4.from(".svg-container .g-arch", {duration: .8, drawSVG: 0, ease: "sine.inOut", stagger: .1}, "start+=2");
      tl4.from(".svg-container .i1-dot", {duration: .75, opacity: 0, y: 70, scale: .8, transformOrigin: "center center", ease: "back.out"}, "start+=.75");
      tl4.from(".svg-container .i1-path", {duration: 1, drawSVG: 0, ease: "sine.inOut", stagger: .1}, "start+=1");

      let masterTl = gsap.timeline({
                      paused: true, 
                      id: 'introMasterTl',
                      onComplete: ()=>{ 
                        //document.querySelector("body").classList.remove("lock-scroll")
                        gsap.to(".scroll-icon", {autoAlpha: 1, duration: .5})
                        scrollIcon.play();
                      }})
      masterTl.add(tl3.timeScale(.85).play())
              .add(tl1.timeScale(1.25).play(), .5)
              .add(tl2.play(), 2)
              .add(tl4.play(), 1.5)
      return masterTl.timeScale(1.25);
    },
  },
  mounted() {
    document.fonts.ready.then(() => { 
      //setting rounded up height and width accounts for rounding up that ScrollTrigger does when pinning elements
      ScrollTrigger.addEventListener("revert", ()=> {
        gsap.set(".svg-container", {clearProps: "height,width"})
        gsap.set(".svg-container", {
          width: Math.ceil(gsap.getProperty(".svg-container", "width")),
          height: Math.ceil(gsap.getProperty(".svg-container", "height")),
        })
      });
      
      this.introTl = this.setupIntroTimeline();
      
      this.introTl.play();
    });
  }
}
</script>

<style lang="less">
  .hero {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    overflow: visible;
    z-index: 5000;
    .svg-container {
      align-self: center; 
      position: relative;
      svg { overflow: visible; transform: translateZ(0); }
      .logo {
        height: 100%;
        .target{ 
          opacity: 0; 
          &.hidden { display: none;}
        }
        .stroke-salmon { stroke: #ff779c;}
        .stroke-pink { stroke: #ffb0f4; }
        path {
          fill: none;
          stroke: #8447ff;
          stroke-miterlimit: 10;
          stroke-dashoffset: 0; 
          stroke-dasharray: none;
        }
        .logo path, .a1-arch, .a2-arch, .i1-path, .i2-path{
          stroke-width: 6.5px;
          stroke-linecap: round;
          transform: translateX(8px) translateY(33.29px);
        }
        .i1-path, .i2-path {
          transform: none;
        }
        .a1-arch, .a2-arch, .i1-path, .i2-path, .g-arch {
          stroke-width: 5.5px;
        }
      }
    }
    .scroll-icon {
      opacity: 0;
      visibility: hidden;
      position: absolute;
      bottom: 20px;
      width: 50px;
      align-self: center;
      @media (orientation: portrait) {
        bottom: 75px;
      }
      &:after{ 
        display: block;
        content: "Scroll for adventure!";
        color: #ffb0f4;
        white-space: nowrap;
        transform: translateX(-100%) translateY(-50%);
        opacity: 0;
        left: -10px;
        top: 50%;
        width: auto;
        position: absolute;
        transition: opacity .25s linear;
      }
      @media (min-width: 800px) {
        &:hover {
          cursor: pointer;
          &:after{
            opacity: 1;
          }
        }
      }
    }
  }
</style>